<!--Program-->
<template>
  <div class="mentee-program">
    <ul v-if="materialList.length>0">
      <li v-for="(item, index) in materialList"
          :key="index">
        <zlr-card-service :title="item.project.univer"
                          style="width: 400px;"
                          kind="ETH"
                          :bgText="item.project.univer.replace(/\s/g,'').substr(0,3).toUpperCase()"
                          :explainList="item.backLogs|backLogsFilters"
                          circle="warning"
                          :dotted=true
                          @click="linkHandle(item)"
                          :dottedList="item.progress.bills | dottedfilter">
          <div>{{item.project.overseasName}}</div>
          <div>Application DDL: {{item.project.deadlineTime}}</div>
        </zlr-card-service>
      </li>
    </ul>
    <zlr-empty v-else></zlr-empty>
  </div>
</template>
<script>
// api
import { getMaterialProject } from '@/api/material'
// components
import ZlrCardService from '_c/card-service/card-service'
import ZlrEmpty from '_c/empty/empty'
export default {
  name: 'mentee-program',
  components: {
    ZlrCardService,
    ZlrEmpty
  },
  data () {
    return {
      materialList: [],
      num: this.$route.params.id
    }
  },
  computed: {},
  mounted () {
    this.getMaterialProject()
  },
  methods: {
    // 获取再来人辅导列表
    getMaterialProject () {
      getMaterialProject({
        num: this.num
      }).then((res) => {
        this.materialList = res.data.model.projects
      })
    },
    linkHandle (item) {
      let programId = item.project.id
      this.$router.push({
        name: 'mentee-program-essay-info',
        params: {
          programId: programId
        }
      })
    }
  },
  filters: {
    backLogsFilters (logs) {
      if (logs.length === 0) return []
      let arr = []
      logs.forEach(item => {
        arr.push({ title: item.content, color: '#85A5FF' })
      })
      return arr
    },
    dottedfilter (dotted) {
      if (dotted.length === 0) return []
      let arr = []
      dotted.forEach(item => {
        let emEdit = item.emEdit || []
        let smEdit = item.smEdit || []
        let emEditActvie = emEdit.filter(item => item.status === 'EDITED').length
        let smEditActvie = smEdit.filter(item => item.status === 'EDITED').length
        arr.push({
          conNum: emEdit.length + smEdit.length,
          activeNum: emEditActvie + smEditActvie
        })
      })
      return arr
    }
  }
}
</script>
<style lang='less' scoped>
</style>
